import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { listTermList } from '../actions/termListActions'

export default function TermListComponent() {
    const dispatch = useDispatch()
    const TermList = useSelector((state) => state.TermList)
    const { loading, error, termlists } = TermList

    useEffect(() => {
        if(termlists == undefined || termlists.length == 0){
            dispatch(listTermList())
        }
    }, [dispatch, termlists])

    return (
        loading ? (
            <option value="0">loading...</option>
        ) : (
            termlists ? (
                (termlists.length > 0) ? (
                    termlists.map(invtyp => (
                        <option key={invtyp.Id} value={invtyp.Id}>{invtyp.Term_Name}</option>
                    ))
                ) : (
                    <option value="0">No Record Exist!</option>
                )
            ) : (
                <option value="0">{error}</option>
            )
        )
    )
}

